const DEFAULT_AUDIO_ENDPOINT = 'https://weloveapple.dk/api/app/article-audio-file';
const EVENT_ENDPOINT = 'https://weloveapple.dk/api/events';

const COPY = {
  da: {
    idle: 'Cedar laver en kort AI-version, kun når du trykker.',
    loading: 'Cedar gør oplæsningen klar...',
    ready: 'Klar til afspilning.',
    playing: 'Afspiller med Cedar.',
    paused: 'Sat på pause.',
    blocked: 'Tryk play i afspilleren for at starte.',
    error: 'Oplæsningen kunne ikke hentes lige nu.',
    buttonIdle: 'Lyt med Cedar',
    buttonLoading: 'Gør klar...',
    buttonPause: 'Pause',
    buttonResume: 'Fortsæt',
    buttonReplay: 'Lyt igen'
  },
  sv: {
    idle: 'Cedar skapar en kort AI-version först när du trycker.',
    loading: 'Cedar gör uppläsningen klar...',
    ready: 'Klar att spela upp.',
    playing: 'Spelar upp med Cedar.',
    paused: 'Pausad.',
    blocked: 'Tryck play i spelaren för att starta.',
    error: 'Uppläsningen kunde inte hämtas just nu.',
    buttonIdle: 'Lyssna med Cedar',
    buttonLoading: 'Förbereder...',
    buttonPause: 'Pausa',
    buttonResume: 'Fortsätt',
    buttonReplay: 'Lyssna igen'
  }
};

function copyFor(language) {
  return COPY[language] || COPY.da;
}

function articleAudioUrl(root) {
  const endpoint = root.dataset.wlaArticleAudioEndpoint || DEFAULT_AUDIO_ENDPOINT;
  const articleUrl = root.dataset.wlaArticleUrl || window.location.href;
  const voice = root.dataset.wlaArticleVoice || 'cedar';
  const language = root.dataset.wlaArticleLanguage || 'da';
  const url = new URL(endpoint, window.location.origin);
  url.searchParams.set('url', articleUrl);
  url.searchParams.set('voice', voice);
  url.searchParams.set('language', language);
  return url.toString();
}

function sendArticleAudioEvent(eventName, root, meta = {}) {
  try {
    const payload = {
      eventName,
      experimentKey: 'article-ai-audio',
      variantKey: root.dataset.wlaArticleVoice || 'cedar',
      surface: 'article',
      placement: 'article-audio-player',
      pagePath: `${window.location.pathname}${window.location.search}`,
      pageUrl: window.location.href,
      value: 0,
      meta
    };
    const body = JSON.stringify(payload);
    if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(EVENT_ENDPOINT, new Blob([body], { type: 'application/json' }))) {
      return;
    }
    fetch(EVENT_ENDPOINT, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
      keepalive: true
    }).catch(() => {});
  } catch {
    // Tracking must never block playback.
  }
}

function setStatus(root, status, text) {
  const statusNode = root.querySelector('[data-wla-article-audio-status]');
  if (statusNode) statusNode.textContent = text;
  root.dataset.wlaArticleAudioState = status;
}

function setButtonText(root, text) {
  const buttonText = root.querySelector('[data-wla-article-audio-button-text]');
  if (buttonText) buttonText.textContent = text;
}

function initArticleAudioRoot(root) {
  if (!root || root.dataset.wlaArticleAudioReady === 'true') return;
  root.dataset.wlaArticleAudioReady = 'true';

  const language = root.dataset.wlaArticleLanguage || 'da';
  const text = copyFor(language);
  const button = root.querySelector('[data-wla-article-audio-button]');
  const player = root.querySelector('[data-wla-article-audio-player]');
  if (!button || !player) return;

  setStatus(root, 'idle', text.idle);

  button.addEventListener('click', () => {
    if (player.src && !player.paused) {
      player.pause();
      return;
    }

    if (!player.src) {
      player.hidden = false;
      player.src = articleAudioUrl(root);
      player.load();
      button.disabled = true;
      setButtonText(root, text.buttonLoading);
      setStatus(root, 'loading', text.loading);
      sendArticleAudioEvent('article_audio_requested', root, {
        language,
        voice: root.dataset.wlaArticleVoice || 'cedar'
      });
    }

    const playPromise = player.play();
    if (playPromise?.catch) {
      playPromise.catch(() => {
        button.disabled = false;
        setButtonText(root, text.buttonResume);
        setStatus(root, 'blocked', text.blocked);
      });
    }
  });

  player.addEventListener('canplay', () => {
    button.disabled = false;
    if (player.paused) {
      setButtonText(root, text.buttonResume);
      setStatus(root, 'ready', text.ready);
    }
  });

  player.addEventListener('playing', () => {
    button.disabled = false;
    setButtonText(root, text.buttonPause);
    setStatus(root, 'playing', text.playing);
    sendArticleAudioEvent('article_audio_started', root, {
      language,
      voice: root.dataset.wlaArticleVoice || 'cedar'
    });
  });

  player.addEventListener('pause', () => {
    if (player.ended) return;
    button.disabled = false;
    setButtonText(root, text.buttonResume);
    setStatus(root, 'paused', text.paused);
  });

  player.addEventListener('ended', () => {
    button.disabled = false;
    setButtonText(root, text.buttonReplay);
    setStatus(root, 'ended', text.ready);
    sendArticleAudioEvent('article_audio_completed', root, {
      language,
      voice: root.dataset.wlaArticleVoice || 'cedar'
    });
  });

  player.addEventListener('error', () => {
    button.disabled = false;
    setButtonText(root, text.buttonIdle);
    setStatus(root, 'error', text.error);
    sendArticleAudioEvent('article_audio_failed', root, {
      language,
      voice: root.dataset.wlaArticleVoice || 'cedar'
    });
  });
}

export function initArticleAudioPlayer() {
  document.querySelectorAll('[data-wla-article-audio]').forEach(initArticleAudioRoot);
}
